"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateLimitRequestDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const rate_limit_request_json_1 = require("./rate-limit-request-json");
exports.RateLimitRequestDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('RateLimitRequest', rate_limit_request_json_1.RateLimitRequestJsonMapper);
